/* eslint-disable */
import { IDateRange } from '@linearb/linjs-common';
// import moment from 'moment';
import { useMemo } from 'react';
import { DateFilter } from './DateFilter';

// const QUERY_DAYS_LIMIT = 30;

export function useDisableGetData(
  _disableDateFilterLimit: boolean,
  range: IDateRange,
  selectedDateFilter: DateFilter
) {
  return useMemo(() => {
    // Return this once product get their shit together

    // const isExceedingRange =
    //   moment(range.to).diff(moment(range.from), 'days') > QUERY_DAYS_LIMIT;

    // return (
    //   (!disableDateFilterLimit && isExceedingRange) || !range.from || !range.to
    // );

    return false;
  }, [range, selectedDateFilter]);
}
